// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "bk_dB";
export var authorBylineContainer = "bk_dy";
export var authorPrefix = "bk_dz";